import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Subtract14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6.25H12V7.75H2V6.25Z'
      fill='currentColor'
    />
  </Svg>
);

Subtract14.displayName = 'Subtract14';
export default Subtract14;
